export default __webpack_public_path__ + "static/media/281.660568d1.svg";